/* eslint-env browser */
import React from 'react';
import { ZMag as Props } from './zmag.types';

const ZMag = (props: Props) => (
  <div id={props.publicationId} className="c-zmag" />
);

export default ZMag;
